import Footer from "../components/footer";
import Header from "../components/header";
import t from "../locales";
import Intro from "./intro";

export default function View() {
  return (
    <>
      <div className="page">
        <Header />
        <title>{t("header.title")}</title>
        <Intro />
        <Footer nonStick={true} />
      </div>
    </>
  );
}
